export const DEVICE_MANAGER_PAGE_KEY = 'device-manager';
